import { Component, inject, signal } from '@angular/core';

import { ButtonComponent, FormDropdownComponent, ModalLayoutComponent } from '@program-suite/ui';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { LookupViewModel } from '@program-suite/data-common';

@Component({
  selector: 'lib-select-wholesaler-modal',
  imports: [
    ModalLayoutComponent,
    FormDropdownComponent,
    ButtonComponent,
    ReactiveFormsModule
],
  templateUrl: './select-wholesaler-modal.component.html',
  styleUrl: './select-wholesaler-modal.component.scss',
})
export class SelectWholesalerModalComponent {
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject(MatDialogRef<SelectWholesalerModalComponent>);
    tenantId = new UntypedFormControl('', Validators.required);
    tenants = signal<LookupViewModel[]>(this.data?.tenants || []);

    onSubmit() {
      if (this.tenantId.invalid) {
        this.tenantId.markAsTouched();
        return;
      }
      const tenantId = this.tenantId.value;
      this.dialogRef.close(tenantId);
    }
}